'use strict';

// reCAPTCHA callbacks must be on window for the Google widget to find them
window.onRecaptchaSuccess = function (token) {
    document.getElementById('g-recaptcha-response').value = token;
};

window.onRecaptchaExpired = function () {
    document.getElementById('g-recaptcha-response').value = '';
};

module.exports = {
    subscribeContact: function () {
        $('form.contact-us').submit(function (e) {
            e.preventDefault();

            var form = this;
            var recaptchaResponse = grecaptcha.getResponse();
            if (!recaptchaResponse) {
                if (!$('.recaptcha-error').length) {
                    $('.g-recaptcha').after('<div class="recaptcha-error text-danger">Por favor, completa el reCAPTCHA.</div>');
                }
                return;
            }
            $('.recaptcha-error').remove();

            // Validar longitud del comentario
            var commentTextArea = $('#contact-comment').val().trim();
            if (commentTextArea.length < 10) {
                if (!$('.comment-error').length) {
                    $('#contact-comment').after('<div class="comment-error text-danger">El comentario debe tener al menos 10 caracteres.</div>');
                }
                return;
            }
            $('.comment-error').remove();

            // Submit nativo a Salesforce WebToCase
            var button = $(form).find('button[type="submit"]');
            button.attr('disabled', true);
            HTMLFormElement.prototype.submit.call(form);
        });
    },
    validateFormEmail: function() {
        $('#contact-email').change(function() {
            if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test($('#contact-email').val()) === false) {
                $('#contact-email').addClass('invalidEmail');
                $('.validation-email-error').removeClass('d-none');
            } else {
                $('#contact-email').removeClass('invalidEmail');
                $('.validation-email-error').addClass('d-none');
            }
        });
    },
    validateFormPhone: function() {
        $('#contact-mobile').on('input', function() {
            var val = $(this).val();
            if (val && !/^[0-9()#,+*\-=.]+$/.test(val)) {
                $(this).val(val.replace(/[^0-9()#,+*\-=.]/g, ''));
            }
        });
    }
};
